import React from 'react';
import { Box, Button, Slider, TextField, Typography } from '@mui/material';
import { Play } from 'lucide-react';
import GlassPaper from '../../../components/GlassPaper';
import FieldLabel from './FieldLabel';
import MetricStrip from './MetricStrip';

export default function BacktestPanel({
    isBookless,
    thresholdInput,
    onThresholdInputChange,
    onThresholdCommit,
    slippageInput,
    onSlippageInputChange,
    onSlippageCommit,
    orderQty,
    onOrderQtyChange,
    onRunBacktest,
    backtestRunning,
    runBacktest,
    metrics,
}) {
    return (
        <GlassPaper sx={{ p: 1.5 }}>
            <FieldLabel label="OBI Backtest" />
            {isBookless && (
                <Typography variant="caption" color="text.disabled" display="block" sx={{ mt: 0.5, mb: 1 }}>
                    Index instrument — no order book; backtest unavailable.
                </Typography>
            )}

            <Box sx={{ mt: isBookless ? 0 : 0.75 }}>
                <FieldLabel label={`Threshold: ${thresholdInput.toFixed(2)}`} />
                <Slider
                    value={thresholdInput}
                    min={0.05}
                    max={0.9}
                    step={0.05}
                    size="small"
                    disabled={isBookless}
                    onChange={(_, v) => onThresholdInputChange(v)}
                    onChangeCommitted={(_, v) => onThresholdCommit(v)}
                />
            </Box>

            <Box sx={{ mt: 1 }}>
                <FieldLabel label={`Slippage: ${slippageInput.toFixed(1)} bps`} />
                <Slider
                    value={slippageInput}
                    min={0}
                    max={10}
                    step={0.5}
                    size="small"
                    disabled={isBookless}
                    onChange={(_, v) => onSlippageInputChange(v)}
                    onChangeCommitted={(_, v) => onSlippageCommit(v)}
                />
            </Box>

            <TextField
                size="small"
                type="number"
                label="Order qty"
                value={orderQty}
                disabled={isBookless}
                onChange={(e) => onOrderQtyChange(Math.max(1, parseInt(e.target.value, 10) || 1))}
                inputProps={{ min: 1, step: 1 }}
                fullWidth
                sx={{ mt: 1.5 }}
            />

            <Button
                variant="contained"
                size="small"
                fullWidth
                startIcon={<Play size={14} />}
                disabled={isBookless || backtestRunning}
                onClick={onRunBacktest}
                sx={{ mt: 1.5, textTransform: 'none', fontWeight: 600 }}
            >
                {backtestRunning ? 'Running…' : runBacktest ? 'Re-run backtest' : 'Run backtest'}
            </Button>

            {runBacktest && metrics && <MetricStrip metrics={metrics} />}
        </GlassPaper>
    );
}
